module.exports = __webpack_public_path__ + "static/media/att_26.9b359156.jpg";